import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../components/Layout';
import OrdersContent from '../../components/Pages/Orders';
import Menu from '../../components/Layout/Menu';

const { displayName } = config;

export default function Orders(): React.ReactNode | null {
  document.title = `${displayName}: Orders`;

  return (
    <Layout
      title="Orders"
      leftMenu={<Menu />}
    >
      <OrdersContent />
    </Layout>
  );
}
